// src/pages/MyGrowthPage/components/ChartsSection.jsx
import React from "react";
import styled from "styled-components";
import {
  LineChart,
  Line,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  AreaChart,
  Area,
} from "recharts";

const ChartsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  transition: 0.5s;
  margin-bottom: 40px;

  @media (max-width: 992px) {
    grid-template-columns: 1fr;
  }
`;

const ChartCard = styled.div`
  background: var(--secondaryBackgroundColor);
  border-radius: 20px;
  padding: 25px;
  border: 1px solid rgba(255, 255, 255, 0.05);
  transition: 0.5s;

  h3 {
    font-size: 1.3rem;
    font-weight: 600;
    margin-bottom: 20px;
    color: var(--fontPrimaryColor);
  }
`;

const ChartContainer = styled.div`
  height: 300px;
  width: 100%;
`;

const ChartsSection = ({ dailyProgress, taskCompletion, habitCompletion }) => {
  const chartData = dailyProgress.filter((d) => d.hasData).slice(-14);
  const last7Days = chartData.slice(-7);

  return (
    <ChartsGrid>
      <ChartCard>
        <h3>Growth Score Trend</h3>
        <ChartContainer>
          <ResponsiveContainer width="100%" height="100%">
            <AreaChart data={chartData}>
              <CartesianGrid
                strokeDasharray="3 3"
                stroke="var(--fontSecondaryColor)"
                opacity={0.1}
              />
              <XAxis
                dataKey="date"
                stroke="var(--fontSecondaryColor)"
                fontSize={12}
              />
              <YAxis
                stroke="var(--fontSecondaryColor)"
                fontSize={12}
                domain={[0, 100]}
                tickFormatter={(value) => `${value}%`}
              />
              <Tooltip
                contentStyle={{
                  backgroundColor: "var(--secondaryBackgroundColor)",
                  border: "1px solid var(--thirdBackgroundColor)",
                  borderRadius: "8px",
                }}
                formatter={(value) => [`${value}%`, "Score"]}
              />
              <Area
                type="monotone"
                dataKey="score"
                stroke="#4a90e2"
                fill="rgba(74, 144, 226, 0.2)"
                strokeWidth={2}
              />
              <Line
                type="monotone"
                dataKey="taskScore"
                stroke="#4caf50"
                strokeWidth={1}
                strokeDasharray="3 3"
                dot={false}
              />
              <Line
                type="monotone"
                dataKey="habitScore"
                stroke="#ff9800"
                strokeWidth={1}
                strokeDasharray="3 3"
                dot={false}
              />
            </AreaChart>
          </ResponsiveContainer>
        </ChartContainer>
      </ChartCard>

      <ChartCard>
        <h3>Task vs Habit Completion</h3>
        <ChartContainer>
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={last7Days}>
              <CartesianGrid
                strokeDasharray="3 3"
                stroke="var(--fontSecondaryColor)"
                opacity={0.1}
              />
              <XAxis
                dataKey="date"
                stroke="var(--fontSecondaryColor)"
                fontSize={12}
              />
              <YAxis
                stroke="var(--fontSecondaryColor)"
                fontSize={12}
                domain={[0, 100]}
                tickFormatter={(value) => `${value}%`}
              />
              <Tooltip
                contentStyle={{
                  backgroundColor: "var(--secondaryBackgroundColor)",
                  border: "1px solid var(--thirdBackgroundColor)",
                  borderRadius: "8px",
                }}
                formatter={(value) => [`${value}%`, "Completion"]}
              />
              <Legend />
              <Bar
                dataKey="taskScore"
                name="Tasks"
                fill="#4caf50"
                radius={[4, 4, 0, 0]}
              />
              <Bar
                dataKey="habitScore"
                name="Habits"
                fill="#2196f3"
                radius={[4, 4, 0, 0]}
              />
            </BarChart>
          </ResponsiveContainer>
        </ChartContainer>
      </ChartCard>
    </ChartsGrid>
  );
};

export default ChartsSection;
